import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  Box,
  Stack,
} from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import noItems from '../../../assets/Hamburger-pana 1.png';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import HomeIcon from '@mui/icons-material/Home';
import AddressHandlerDialog from './AddressHandler';
import { environment } from 'apps/table-tuck-web/src/environments/environment';
import { useSelector } from 'react-redux';
import { firestore } from '../../../../../../libs/firebase-service/src';
import WorkIcon from '@mui/icons-material/Work';
import DeleteIcon from '@mui/icons-material/Delete';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import { useDispatch } from 'react-redux';
import { userAddresses } from '../../../../../../libs/redux-slices/src';
import { useTranslation } from 'react-i18next';

const Address = ({ renderAddButton }) => {
  // Listen for global event to open dialog from header button
  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener('openAddAddressDialog', handler);
    return () => window.removeEventListener('openAddAddressDialog', handler);
  }, []);
  const [open, setOpen] = React.useState(false);
  const [editAddress, setEditAddress] = useState(null);
  const [openDelete, setOpenDelete] = React.useState(false);
  const adresses = useSelector((state) => state.authReducer.userAddresses);
  const [adressess, setAdresses] = useState([]);
  const token = useSelector((state) => state.authReducer.token);
  const [adressToDelete, setAdressToDelete] = useState('');
  const dispatch = useDispatch();

  const handleClosee = () => {
    setOpenDelete(false);
  };

  const deleteAdress = async () => {
    if (adressToDelete) {
      const docRef = firestore
        .collection('users')
        .doc(token)
        .collection('addresses')
        .doc(adressToDelete);
      await docRef
        .delete()
        .catch((e) => {
          console.log(e);
        })
        .then(() => {
          const indexToDelete = adresses.findIndex(
            (obj) => obj.id === adressToDelete
          );
          if (indexToDelete !== -1) {
            const newArray = adresses
              .slice(0, indexToDelete)
              .concat(adresses.slice(indexToDelete + 1));
            dispatch(userAddresses(newArray));
          } else {
            console.log('Object not found');
          }
        });
    }
    setOpenDelete(false);
    setAdressToDelete('');
  };

  const handleClickOpen = () => {
    setEditAddress(null);
    setOpen(true);
  };

  const handleEditClick = (address) => {
    setEditAddress(address);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setEditAddress(null); // Clear edit address when closing
  };
  const [t, i18n] = useTranslation();

  const visibleAddresses = useMemo(
    () => (adresses || []).filter((address) => address?.isDisplayed !== false),
    [adresses]
  );

  // Responsive grid: 2 per row on md+, 1 per row on xs
  const isMobile = useMediaQuery('(max-width:600px)');
  const isTablet = useMediaQuery('(max-width:900px)');

  return (
    <Box className="mt-3.5" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
      <Box mb={2}>
        {renderAddButton ? (
          renderAddButton({ onClick: handleClickOpen })
        ) : (
          <Button
            disableRipple={true}
            disableFocusRipple={true}
            disableTouchRipple={true}
            variant="text"
            style={{
              width: '100%',
              boxShadow:
                '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
              color: environment.mainColor,
              padding: '10px',
              borderRadius: '20px',
              fontWeight: 'bold',
            }}
            onClick={handleClickOpen}
          >
            <AddLocationAltIcon /> {t('profilee.addNewAddress')}
          </Button>
        )}
      </Box>
      <AddressHandlerDialog
        open={open}
        handleClose={handleClose}
        address={editAddress}
      />

      {visibleAddresses.length === 0 ? (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}
        >
          <img
            src={noItems}
            alt={`No items in favorites`}
            style={{
              maxWidth: '363px',
              width: '100%',
              maxHeight: '320px',
              marginBottom: '20px',
              objectFit: 'cover',
            }}
          />
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              marginBottom: '8px',
              color: '#172B4D',
              fontSize: {
                xs: '14px',
                md: '16px',
                lg: '20px',
              },
              fontFamily: 'Jost, sans-serif',
              textAlign: 'center',
            }}
          >
            There is no address
          </Typography>
        </div>
      ) : (
        <Grid container spacing={2}>
          {visibleAddresses.map((c, idx) => (
            <Grid item xs={12} sm={6} md={6} key={c.id || idx}>
              <Stack
                sx={{
                  borderRadius: '8px',
                  boxShadow: 'none',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  gap: 1,
                  border: '1px solid #EDEDED',
                  height: '100%',
                  padding: '10px 20px',
                }}
              >
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      fontFamily: 'Jost, sans-serif',
                      color: '#172B4D',
                      fontSize: '20px',
                      mb: 0.5,
                    }}
                  >
                    {c?.nickName?.toLowerCase() === 'university' ||
                    c?.nickName?.toLowerCase() === 'home' ||
                    c?.nickName?.toLowerCase() === 'work'
                      ? t(`profilee.${c?.nickName?.toLowerCase()}`)
                      : c?.nickName || 'Address'}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ color: '#666666', fontFamily: 'Jost, sans-serif' }}
                  >
                    {c.displayName}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Button
                    size="small"
                    color="error"
                    sx={{ textTransform: 'none', fontWeight: 500 }}
                    onClick={() => {
                      setAdressToDelete(c.id);
                      setOpenDelete(true);
                    }}
                  >
                    Remove
                  </Button>
                  <Button
                    size="small"
                    color="success"
                    sx={{ textTransform: 'none', fontWeight: 500 }}
                    onClick={() => handleEditClick(c)}
                  >
                    Edit
                  </Button>
                </Box>
                <Dialog
                  style={{ zIndex: 10 }}
                  open={openDelete}
                  keepMounted
                  onClose={handleClose}
                  aria-describedby="alert-dialog-slide-description"
                  dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                  slotProps={{
                    backdrop: {
                      style: {
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                      },
                    },
                  }}
                  PaperProps={{
                    style: {
                      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                      backgroundColor: 'white',
                    },
                  }}
                >
                  <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                      {t('profilee.youWantDeleteAdress')}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      style={{ color: environment.mainColor }}
                      onClick={handleClosee}
                    >
                      {t('profilee.cancel')}
                    </Button>
                    <Button
                      style={{ color: environment.mainColor }}
                      onClick={() => deleteAdress()}
                    >
                      {t('profilee.delete')}
                    </Button>
                  </DialogActions>
                </Dialog>
              </Stack>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default Address;
